import { render, staticRenderFns } from "./AppAgendaAluno.vue?vue&type=template&id=d792d11c&"
import script from "./AppAgendaAluno.vue?vue&type=script&lang=js&"
export * from "./AppAgendaAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports